<template>
  <div>
    <svg
      v-if="percent < 100"
      class="circle-progress"
      :height="size"
      :width="size"
      :viewBox="`0 0 ${size} ${size}`"
    >
      <circle
        class="total"
        :cx="half"
        :cy="half"
        :r="radius"
        :stroke-width="`${width - (percent > 0 ? 2 : 0)}px`"
        :stroke="backgroundColor"
      />
      <circle
        class="progress"
        :cx="half"
        :cy="half"
        :r="radius"
        :stroke-width="`${width}px`"
        :stroke="color"
        stroke-linecap="round"
      />
      <text
        :dx="percent.toString().length === 1 ? 14 : 11"
        :dy="-17"
        class="percent-text"
      >
        {{ percent }}%
      </text>
    </svg>
    <elIcon
      v-else
      name="check"
      class="text-success"
      :size="checkSize"
    />
  </div>
</template>

<script>
import elIcon from './elIcon.vue'

export default {
  name: 'CircleProgressBar',
  components: {
    elIcon
  },
  props: {
    size: {
      type: Number,
      default: 30
    },
    checkSize: {
      type: String,
      default: 'lg'
    },
    width: {
      type: Number,
      default: 3
    },
    backgroundColor: {
      type: String,
      default: 'rgb(64, 67, 70)'
    },
    color: {
      type: String,
      default: '#3b42f3'
    },
    percent: {
      type: Number,
      default: 0
    }
  },
  computed: {
    half() {
      return this.size / 2
    },
    radius() {
      return this.half - this.width
    },
    arcOffset() {
      if (this.percent > 100) return
      return this.arcLength * ((100 - this.percent) / 100)
    },
    arcLength() {
      return 2 * Math.PI * this.radius
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~@ui/styles/src/scss/utils/lib";

.circle-progress {
  transform: rotate(-90deg);
}

.percent-text {
  font-weight: 100;
  font-size: .9em;
  transform: rotate(90deg);
  stroke: $grey-90;
}

.total, .progress {
  fill: none;
}

.total {
  animation: fade 3s ease-out infinite;
}

.progress {
  stroke-dasharray: v-bind('arcLength');
  stroke-dashoffset: v-bind('arcOffset');
}

@keyframes fade {
  100% {
    opacity: 1;
  }

  50% {
    opacity: 0.5;
  }

  0% {
    opacity: 1;
  }
}
</style>
